import React from "react";
import { Button } from "@xometry/xometry_loft";
import {
  CustomerRFQContents,
  CustomerRFQPageLayout,
} from "./CustomerRFQPage.style";
import { CustomerQuoteRequest } from "../CustomerRFQ";

export const CustomerRFQPage: React.FC = () => {
  return (
    <CustomerRFQPageLayout>
      <CustomerQuoteRequest isModalOnly={false}>
        <CustomerRFQContents>
          <i className="far fa-cloud-upload" />
          <Button kind="primary">Start an RFQ Now</Button>
          <span className="prompt">
            Send us all your project files and we&apos;ll build the quote
          </span>
        </CustomerRFQContents>
      </CustomerQuoteRequest>
    </CustomerRFQPageLayout>
  );
};
